import { PageRoutes } from "../constants/historyGaming";
import Profile from "../pages/Profile/Profile";
import { LevelDetail } from "../pages/LevelDetail";
import MainHeader from "../components/common/MainHeader/MainHeader";
import Friends from "../pages/Friends/Friends";
import { EditProfile } from "../pages/EditProfile";
import { Settings } from "../pages/Settings";
import { Languages } from "../pages/Languages";
import SearchFriends from "../pages/SearchFriends/SearchFriends";
import { Support } from "../pages/Support";
import { Suspense } from "react";
import GamingLoading from "../components/common/GamingLoading/GamingLoading";
import { BundleDetail, Homepage, Rank, Shop } from "./lazyComponent";
import Videos from "../pages/Videos/Videos";
import SearchVideo from "../pages/SearchVideo/SearchVideo";
import BottomNavbar from "../components/common/BottomNavbar/BottomNavbar";
import NotificationsPage from "../pages/Notifications/Notifications";
import { GuestPage } from "../components/common/GuestPage";
import Onboarding from "../pages/Onboarding/Onboarding";
import GamePlay from "../pages/GamePlay/GamePlay";
import Esport from "../pages/Esports/Esports";
import SetProfile from "../pages/SetProfile/SetProfile";
import { PlayIframe } from "../pages/PlayIframe";
import Subscription from "../pages/Subscription/Subscription";
import Store from "../pages/Store/Store";
import { VoucherInventoryDetail } from "../components/common/VoucherInventoryDetail/VoucherInventoryDetail";
import { VoucherItemDetail } from "../components/common/VoucherItemDetail/VoucherItemDetail";

const DefaultLayout = ({ children }: { children: React.ReactNode }) => (
  <>
    <MainHeader key={window.location.pathname} />
    <Suspense fallback={<GamingLoading />}>{children}</Suspense>
    <BottomNavbar />
  </>
);
const ROUTES = [
  {
    path: PageRoutes.HomePage,
    element: <DefaultLayout>{<Homepage />}</DefaultLayout>,
  },
  {
    path: PageRoutes.Rank,
    element: <DefaultLayout>{<Rank />}</DefaultLayout>,
  },
  {
    path: PageRoutes.Esports,
    element: <DefaultLayout>{<Esport />}</DefaultLayout>,
  },
  {
    path: PageRoutes.Friends,
    element: <DefaultLayout>{<Friends />}</DefaultLayout>,
  },
  {
    path: `${PageRoutes.Store}`,
    element: <DefaultLayout>{<Store />}</DefaultLayout>,
  },
  {
    path: `${PageRoutes.VoucherDetail}/:bundleId`,
    element: <VoucherInventoryDetail />,
  },
  {
    path: `${PageRoutes.VoucherItemDetail}/:bundleId/:itemId`,
    element: <VoucherItemDetail />,
  },
  {
    path: `${PageRoutes.GamePlay}/:id`,
    element: <GamePlay />,
  },
  {
    path: PageRoutes.Feed,
    element: <PlayIframe />,
  },
  {
    path: `${PageRoutes.VideosVodacom}`,
    element: <DefaultLayout>{<Videos />}</DefaultLayout>,
  },
  { path: PageRoutes.Level, element: <LevelDetail /> },
  { path: PageRoutes.EditProfile, element: <EditProfile /> },
  {
    path: `${PageRoutes.Profile}`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Profile />
      </>
    ),
  },
  {
    path: `${PageRoutes.Profile}/:userId`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Profile />
      </>
    ),
  },
  {
    path: `${PageRoutes.Shop}`,
    element: <DefaultLayout>{<Shop />}</DefaultLayout>,
  },

  {
    path: `${PageRoutes.BundleDetail}/:bundleId`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Suspense fallback={<GamingLoading />}>
          <BundleDetail />
        </Suspense>
      </>
    ),
  },
  { path: PageRoutes.Settings, element: <Settings /> },
  { path: PageRoutes.Languages, element: <Languages /> },
  { path: PageRoutes.Subscription, element: <Subscription /> },
  { path: PageRoutes.Search, element: <SearchFriends /> },
  { path: PageRoutes.Faq, element: <Support type="faq" /> },
  { path: PageRoutes.TermsAndConditions, element: <Support type="term" /> },
  { path: PageRoutes.CookiePolicy, element: <Support type="cookie" /> },
  { path: PageRoutes.PrivacyPolicy, element: <Support type="privacy" /> },
  { path: PageRoutes.Videos, element: <Videos /> },
  { path: PageRoutes.SearchVideo, element: <SearchVideo /> },
  { path: PageRoutes.Notifications, element: <NotificationsPage /> },
  {
    path: `${PageRoutes.Apps}/:appId`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Homepage />
      </>
    ),
  },
  { path: PageRoutes.Onboarding, element: <Onboarding /> },
  { path: PageRoutes.SetProfile, element: <SetProfile /> },
  { path: PageRoutes.Guest, element: <GuestPage /> },
];

export const routes = ROUTES.map(({ path, element }, idx) => ({
  path,
  element: element,
  id: `route-${path}-${idx}`,
}));
